import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import StickyBar from "./StickyBar"
import qs from "query-string"
import ListItem from "./ListItem"
import isOnDemand from "../../utils/isOnDemand"
import "./styles.less"

const SearchParams = ({
  className = "",
  setFiltersOpen = () => null,
  locationSearch = "",
}) => {
  const [filter, setFilter] = useState(false)

  const [params, setParams] = useState({})

  useEffect(() => {
    const tempParams = qs.parse(locationSearch)
    setParams(tempParams)
  }, [locationSearch])

  useEffect(() => {
    document.addEventListener("mousedown", closeFilters)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", closeFilters)
    }
  }, [])

  useEffect(() => {
    if (filter) {
      setFiltersOpen(true)
    } else {
      setFiltersOpen(false)
    }
  }, [filter])

  const closeFilters = (e) => {
    let outside = true
    const nodes = document.getElementsByClassName("searchParamsLi")
    if (nodes.length > 0) {
      for (let index = 0; index < nodes.length; index++) {
        const node = nodes.item(index)
        if (node.contains(e.target)) {
          outside = false
        }
      }
    }
    if (outside) {
      setFilter(null)
    }
  }

  const user = {}

  return (
    <>
      {Object.keys(params).length > 0 && !params.current_staff && (
        <div>
          <button
            className={`btn ws-ts-force-message`}
            onClick={() => setFilter(filter ? null : "current_staff")}
          >
            Select team size to view prices.
          </button>
        </div>
      )}
      <ul
        className={`searchParamsUl search-params ${className} ${
          filter ? "active" : ""
        }`}
      >
        <ListItem
          id="current_staff"
          filter={filter}
          setFilter={setFilter}
          type="current_staff"
          className={!!params.current_staff ? "" : "animate"}
          title="How many people need office space?"
          isActive={!!params.current_staff}
          initialValue={params.current_staff || null}
          label={"Team Size"}
          user={user || {}}
        />

        <ListItem
          id="move_in_date"
          filter={filter}
          setFilter={setFilter}
          type="date_picker"
          initialValue={params.move_in_date || null}
          isActive={!!params.move_in_date}
          label={isOnDemand() ? "Start &amp; End date" : "Move-in Date"}
          user={user || {}}
          faded={!params.current_staff}
          toolTipText={"Please select team size first to add move-in date"}
          toolTipActive={!params.current_staff}
          className={isOnDemand() ? "weekend-disabled" : ""}
        />
      </ul>
      <StickyBar
        showFilter={() => {
          setFilter("current_staff")
          window.scroll(0, 0)
        }}
      />
    </>
  )
}

SearchParams.propTypes = {
  className: PropTypes.string,
  setFiltersOpen: PropTypes.func,
}
export default SearchParams
